import { TweetContext } from "context/tweetContext";
import { checkTweetValid, scheduleTweet } from "controllers/schedule";
import { useSession } from "next-auth/react";
import { useContext } from "react";
import { getAccount } from "utils/sessionHelper";

export const useAddToQueue = () => {
  const { data: session } = useSession() ?? {};
  const tweetContext: any = useContext(TweetContext);

  const handleAddToQueue = (draft: any) => async () => {
    let dataToSend = {
      idUser: getAccount(session)?.id,
      idAccount: getAccount(session)?.idAccount,
      twUserName: getAccount(session)?.twUserName,
      id: draft.id,
      text: draft.text,
      isScheduled: true,
      scheduledTime: tweetContext.nextSlot,
      isAutoPlug: false,
      isAutoRetweet: getAccount(session)?.isAutoRetweet ?? false,
      autoRetweetHours: getAccount(session)?.autoRetweetHours ?? 12,
      autoRetweetTimes: getAccount(session)?.autoRetweetTimes ?? 1,
      isPreventLinkExpand: getAccount(session)?.isPreventLinkExpand ?? 1,
      isPreventLinkExpandAutoPlug:
        getAccount(session)?.isPreventLinkExpand ?? 1,
      isRetweeted: false,
      isPlugged: false,
      autoRtWithOtherAccounts:
        getAccount(session)?.autoRtWithOtherAccounts ?? false,
    };

    if (
      !(await checkTweetValid([], session, tweetContext, dataToSend, undefined))
    ) {
      return;
    }
    await scheduleTweet(
      undefined,
      undefined,
      dataToSend,
      getAccount(session)?.timezone,
      tweetContext
    );
    tweetContext.refresher({});
  };

  return handleAddToQueue;
}